<div class="container">
    <div class="common loginformsection">				
        <div class="loginform">
            <div class="logodiv text-center">
                <a href="#" routerLink="/dashboard"><img src="assets/images/logo.png"></a>
            </div>
            <h6 class="formheading">Forgot Password</h6>
            <form (submit) = "forgotPassword($event)">
                <div class="form-group">						  
                  <input type="email" class="form-control email inptdesgn" id="email" placeholder="Enter email" name="email">
                  <span class="inputValidation">{{ emailError }}</span>
                </div>
                <div class="form-group text-center">
                    <input type="submit" class="sgninbtn smallhndrd" name="sgninbtn" value="Submit">
                </div>
            </form>
            <div class="signuptextdiv">
                <p class="privcttxt text-center">New to Nuflorist? <a href="javascript:void(0)" routerLink="/signup">Sign Up</a> </p>
            </div>
        </div>
    </div>
</div>